module.exports = __webpack_public_path__ + "static/media/logo.eb55bd10.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 79
// module chunks = 0